import bck from "../bck";
import m from "mithril";
import customblock from "../../custom-block-wrapper/custom-block-wrapper";

export default () => {
	let initialted = false;
	let expanded = false;
	let initialExpanded = false;
	let blocktitle = null;
	let tid = null;
	let tact = null;
	let fixed_expanded = false;

	let hasNoData = false;

	function SetAsHasNoData() {
		hasNoData = true;
	}

	function ToggleExpanded() {
		expanded = !expanded;
	}

	return {
		view: (v) => {
			if (!initialted) {
				tid = v.attrs.tid;
				expanded = !!v.attrs.expanded;
				initialExpanded = expanded;
				fixed_expanded = v.attrs.fixed_expanded;
				blocktitle = v.attrs.blocktitle;
				tact = v.attrs.tact;
				initialted = true;

				// console.log({blocktitle});
			}

			return m(".block-wrapper", [
				blocktitle
					? initialExpanded && hasNoData
						? null
						: m(
								"a.Link.DisplayBlockTitle.blocktype",
								{
									class: expanded ? "Expanded" : "Closed",
									onclick: () => {
										if (!fixed_expanded) {
											ToggleExpanded();
										}
									},
								},
								blocktitle
						  )
					: null,
				!hasNoData && expanded
					? v.attrs.blockcode == "999"
						? m(customblock, {
								tid: tid,
								prid: v.attrs.prid,
								category: v.attrs.category,
								defaultpagesize: v.attrs.defaultpagesize,
								appcode: v.attrs.appcode,
								tact: tact,
								groups: v.attrs.groups,
								blockcode: v.attrs.blockcode,
								onSetHasNoData: SetAsHasNoData,
								hiddenFieldID: v.attrs.hiddenFieldID,
								hiddenFieldColumn: v.attrs.hiddenFieldColumn,
								selectsingle: v.attrs.selectsingle,
								showasfields: v.attrs.showasfields,
								stripdata: v.attrs.stripdata,
								fixed_editable: v.attrs.fixed_editable,
								refrestime: v.attrs.refreshtime,
								cachetime: v.attrs.cachetime,
						  })
						: m(bck, {
								// key: `${tid}data`,
								tid: tid,
								prid: v.attrs.prid,
								category: v.attrs.category,
								defaultpagesize: v.attrs.defaultpagesize,
								appcode: v.attrs.appcode,
								tact: tact,
								groups: v.attrs.groups,
								blockcode: v.attrs.blockcode,
								onSetHasNoData: SetAsHasNoData,
								hiddenFieldID: v.attrs.hiddenFieldID,
								hiddenFieldColumn: v.attrs.hiddenFieldColumn,
								selectsingle: v.attrs.selectsingle,
								showasfields: v.attrs.showasfields,
								stripdata: v.attrs.stripdata,
								fixed_editable: v.attrs.fixed_editable,
								row: v.attrs.row,
								refreshtime: v.attrs.refreshtime,
								cachetime: v.attrs.cachetime,
						  })
					: null,
				!initialExpanded && hasNoData && expanded ? m("span", "There is no data") : null,
			]);
		},
	};
};
